function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.31948 8.54075C9.10295 8.41382 8.83681 8.41649 8.62135 8.54449L7.53015 9.19462C7.28588 9.34022 6.98082 9.32315 6.75682 9.14822C6.36962 8.84582 5.74615 8.33702 5.20375 7.79462C4.66135 7.25222 4.15255 6.62876 3.85015 6.24155C3.67522 6.01755 3.65815 5.71249 3.80375 5.46822L4.45388 4.37702C4.58242 4.16155 4.58348 3.89329 4.45655 3.67676L2.85548 0.941822C2.70028 0.677289 2.39202 0.547155 2.09388 0.620222C1.80428 0.690622 1.42828 0.862355 1.03415 1.25702C-0.199983 2.49116 -0.85545 4.57275 3.78562 9.21382C8.42668 13.8549 10.5077 13.2 11.7424 11.9653C12.1376 11.5701 12.3088 11.1936 12.3797 10.9034C12.4517 10.6058 12.3237 10.2997 12.0597 10.145C11.4005 9.75942 9.97868 8.92689 9.31948 8.54075Z",
  fill: "#2F7067"
});

var SvgCall = function SvgCall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/call.67de54a3.svg";
export { ForwardRef as ReactComponent };